import Rive from 'rive-react';
import styled from 'styled-components';

export default function Loading() {
  return (
    <LoadingContainer>
      {Rive && <Rive src="/animations/splash.riv" style={{ width: 100, height: 100 }} />}
    </LoadingContainer>
  );
}

const LoadingContainer = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
`;
